// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Scalar from "../../core/Scalar.res.js";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as OrderRoutes from "../../app/Order/OrderRoutes.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as TableDateCell from "../../resources/tables/TableDateCell.res.js";
import * as SupplierRoutes from "../../app/Supplier/SupplierRoutes.res.js";
import * as AmountTableCell from "../TableCell/AmountTableCell.res.js";
import * as ShowAllDataLink from "../../resources/navigation/ShowAllDataLink.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OrderNameTableCell from "../Order/OrderNameTableCell.res.js";
import * as CatalogVariantOrderSupplyTableCard__Queries from "./CatalogVariantOrderSupplyTableCard__Queries.res.js";

function keyExtractor(row) {
  return row.id + "-supply";
}

let Row = {
  keyExtractor: keyExtractor
};

function tableColumns(allShopsFiltered) {
  return [
    {
      key: "supply-name",
      name: I18n.t("Number"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 160
        },
        width: {
          NAME: "pct",
          VAL: 30
        },
        margin: "normal"
      },
      render: param => {
        let match = param.data;
        let shopName = allShopsFiltered ? match.shopName : undefined;
        return JsxRuntime.jsx(OrderNameTableCell.make, {
          value: match.name,
          shopName: shopName,
          id: match.id
        });
      }
    },
    {
      key: "supply-supplier",
      name: I18n.t("Supplier"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 140
        },
        width: {
          NAME: "pct",
          VAL: 20
        },
        margin: "small"
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(TextLink.make, {
          text: match.supplierCompanyName,
          to: {
            TAG: "Route",
            _0: SupplierRoutes.showRoute(match.supplierId)
          }
        });
      }
    },
    {
      key: "supply-date",
      name: I18n.t("Reception date"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 150
        },
        width: {
          NAME: "fr",
          VAL: 2
        },
        margin: "huge"
      },
      render: param => JsxRuntime.jsx(TableDateCell.make, {
        value: param.data.receptionDate
      })
    },
    {
      key: "supply-amount",
      name: I18n.t("Amount"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(AmountTableCell.make, {
          value: match.totalAmountExcludingTaxes,
          secondaryValue: match.totalAmountIncludingTaxes,
          decimalPrecision: 3
        });
      }
    },
    {
      key: "supply-quantity",
      name: I18n.t("Quantity"),
      layout: {
        width: {
          NAME: "fr",
          VAL: 2
        },
        alignX: "center"
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.data.quantity
      })
    }
  ];
}

function CatalogVariantOrderSupplyTableCard(props) {
  let cku = props.cku;
  let match = CatalogVariantOrderSupplyTableCard__Queries.OrderSuppliesQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryResults = match[1];
  let executeQuery = match[0];
  let activeShop = Auth.useActiveShop();
  let match$1 = Navigation.useUrl();
  React.useEffect(() => {
    executeQuery(undefined, undefined, CatalogVariantOrderSupplyTableCard__Queries.OrderSuppliesQuery.makeVariables(Scalar.CKU.serialize(cku), CatalogVariantOrderSupplyTableCard__Queries.edgesPerFetch, CatalogVariantOrderSupplyTableCard__Queries.OrderSuppliesQuery.makeInputObjectInputOrderProductsByVariantCkuQueryFilter("INCLUDED", {
      _after: undefined,
      _before: Scalar.Datetime.serialize(new Date(Date.now())),
      _between: undefined
    }, activeShop !== undefined ? CatalogVariantOrderSupplyTableCard__Queries.OrderSuppliesQuery.makeInputObjectInFilter([activeShop.id], undefined) : undefined, undefined), undefined));
  }, [activeShop]);
  let match$2 = Auth.useScope();
  let allShopsFiltered;
  allShopsFiltered = match$2.TAG === "Organisation" ? match$2.activeShop === undefined : false;
  let columns = React.useMemo(() => tableColumns(allShopsFiltered), [allShopsFiltered]);
  let tmp;
  if (queryResults.TAG === "Executed") {
    let match$3 = queryResults._0;
    let match$4 = match$3.data;
    if (match$4 !== undefined) {
      let match$5 = match$4.orderProductsByVariantCku;
      let rows = Stdlib_Array.filterMap(match$5.edges, param => {
        let orderProduct = param.node;
        let match = orderProduct.order;
        let match$1 = Stdlib_Option.flatMap(orderProduct.order, order => order.supplier);
        if (match !== undefined && match$1 !== undefined) {
          return {
            id: match.id,
            shopName: match.shopName,
            name: Stdlib_Option.getOr(match.name, "?"),
            receptionDate: match.receptionFinishedAt,
            quantity: orderProduct.quantity.toString(),
            totalAmountExcludingTaxes: orderProduct.totalAmountExcludingTaxes,
            totalAmountIncludingTaxes: orderProduct.totalAmountIncludingTaxes,
            supplierId: match$1.id,
            supplierCompanyName: match.supplierCompanyName
          };
        }
      });
      let placeholderEmptyState = JsxRuntime.jsx(Placeholder.make, {
        status: "NoDataAvailable",
        customText: I18n.t("No order has been yet recorded"),
        compact: true
      });
      let data = {
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: rows
        }
      };
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(TableView.make, {
            data: data,
            columns: columns,
            keyExtractor: keyExtractor,
            placeholderEmptyState: placeholderEmptyState
          }),
          match$5.pageInfo.hasNextPage === true ? JsxRuntime.jsx(ShowAllDataLink.make, {
              href: match$1.pathname + OrderRoutes.orderSupplyRoute
            }) : null
        ]
      });
    } else {
      tmp = match$3.loading ? JsxRuntime.jsx(Placeholder.make, {
          status: "Loading"
        }) : JsxRuntime.jsx(Placeholder.make, {
          status: "Error"
        });
    }
  } else {
    tmp = JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  }
  return JsxRuntime.jsx(Card.make, {
    children: tmp,
    title: I18n.t("Orders"),
    variation: "table"
  });
}

let make = React.memo(CatalogVariantOrderSupplyTableCard);

let OrderSupplies;

let Query;

export {
  OrderSupplies,
  Query,
  Row,
  tableColumns,
  make,
}
/* make Not a pure module */
